export class MechanicValidatorRobber {
    get robberLocation() {
        return this.robberState.locationTileIndex;
    }
    landTilesWithoutRobber() {
        const robberArray = [];
        for (const [index, tile] of this.mapValidator.tileState.tiles.entries()){
            if (index == this.robberState.locationTileIndex) continue;
            if (!tile.isTileLand()) continue;
            robberArray.push(index);
        }
        return robberArray;
    }
    whereCanPlayerPlaceRobber(playersProtectedByFriendlyRobber) {
        const landTilesWithoutRobber = this.landTilesWithoutRobber();
        const tilesToHighlight = [];
        for (const tile of landTilesWithoutRobber){
            if (this.mapValidator.arePlayersProtectedByFriendlyRobberTouchingTile(playersProtectedByFriendlyRobber, tile)) continue;
            tilesToHighlight.push(tile);
        }
        if (tilesToHighlight.length == 0) tilesToHighlight.push(this.robberState.locationTileIndex);
        return tilesToHighlight;
    }
    isEdgeTouchingTileWithRobber(tileEdge) {
        for (const touchingHexFaces of tileEdge.hexEdge.touchingFaces()){
            const tileIndex = this.mapValidator.tileState.getTileHexIndex(touchingHexFaces);
            if (tileIndex == undefined) continue;
            if (tileIndex == this.robberState.locationTileIndex) return true;
        }
        return false;
    }
    constructor(mapValidator, robberState){
        this.mapValidator = mapValidator;
        this.robberState = robberState;
    }
}
